import { Droplets, Truck, Snowflake, Check } from "lucide-react";

const SERVICES = [
  {
    id: "junk-removal",
    icon: Truck,
    title: "Junk Removal",
    desc: "Full-service hauling for homes and businesses. We load, we lift, we haul — you point, it's gone.",
    points: ["Furniture & appliance removal", "Garage & basement cleanouts", "Construction debris hauling"],
    img: "/junk_removal.png",
    span: "md:col-span-7",
  },
  {
    id: "power-washing",
    icon: Droplets,
    title: "Power Washing",
    desc: "Blast away years of grime, salt stains and mildew. Driveways, decks, siding and more.",
    points: ["Driveways & walkways", "Decks, fences & siding", "Commercial storefronts"],
    img: "/power_washing.png",
    span: "md:col-span-5",
  },
  {
    id: "snow-plowing",
    icon: Snowflake,
    title: "Snow Plow Removal",
    desc: "When the storm hits, we show up. Reliable residential and commercial snow clearing all winter long.",
    badge: "Season Contracts $800–$1,200",
    points: ["Driveway & lot plowing", "Walkway shoveling & salting", "Seasonal contracts: $800–$1,200 based on property size"],
    img: "/snow_plowing.png",
    span: "md:col-span-12",
  },
];

export default function Services() {
  return (
    <section data-testid="services-section" id="services" className="py-24 sm:py-32 px-6 lg:px-8 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs tracking-[0.3em] uppercase font-bold text-[#F59E0B] mb-4">What We Do</p>
        <h2 className="font-display uppercase tracking-tight text-4xl sm:text-5xl mb-4">Three Services. One Warrior.</h2>
        <p className="text-neutral-400 max-w-2xl mb-14">Call for a quote — every job is priced fair and finished right.</p>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {SERVICES.map((s) => (
            <article
              key={s.id}
              data-testid={`service-card-${s.id}`}
              className={`${s.span} group relative min-h-[380px] md:min-h-[420px] border border-white/10 overflow-hidden flex flex-col justify-end p-8 transition-transform duration-300 hover:-translate-y-1 shadow-[0_8px_30px_rgb(0,0,0,0.5)]`}
            >
              <div
                className="absolute inset-0 bg-cover bg-center max-h-[80vh] transition-transform duration-500 group-hover:scale-105"
                style={{ backgroundImage: `url(${s.img})` }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/20" />
              <div className="relative">
                {s.badge && (
                  <span data-testid="snow-contract-badge" className="inline-block bg-[#F59E0B] text-black text-xs tracking-[0.15em] uppercase font-bold px-3 py-1.5 mb-4">
                    {s.badge}
                  </span>
                )}
                <s.icon className="w-8 h-8 text-[#F59E0B] mb-4" strokeWidth={2} />
                <h3 className="font-display uppercase tracking-tight text-2xl sm:text-3xl mb-2">{s.title}</h3>
                <p className="text-neutral-300 text-sm sm:text-base max-w-lg mb-4">{s.desc}</p>
                <ul className="space-y-1.5">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-2 text-sm text-neutral-300">
                      <Check className="w-4 h-4 text-[#F59E0B]" strokeWidth={3} /> {p}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
